// extracted by mini-css-extract-plugin
export default {"templates":"m7Ouwg","searchFadeIn":"F8df89"};